import React from 'react';
import LastUsedBadge from './LastUsedBadge';

interface AuthDividerProps {
  /** Sits between the hairlines: static wording on the login and SSO cards, the disclosure toggle on sign-up. */
  children: React.ReactNode;
  lastUsed?: boolean;
}

export function AuthDivider({ children, lastUsed = false }: AuthDividerProps) {
  return (
    <div className="relative flex items-center gap-4 text-sm text-neutral-800">
      {lastUsed ? <LastUsedBadge className="right-0 top-1/2 -translate-y-1/2" /> : null}
      <span className="h-px flex-1 bg-neutral-300" aria-hidden="true" />
      {children}
      <span className="h-px flex-1 bg-neutral-300" aria-hidden="true" />
    </div>
  );
}

export default AuthDivider;
